import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

function TermsOfService() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="back-link">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 3l-5 5 5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Back to Home
        </Link>
        
        <h1 className="legal-title">Terms of Service</h1>
        <p className="last-updated">Last updated: November 26, 2025</p>
        
        <div className="legal-content">
          <p>
            Welcome to Discoverly, operated by Flux Software, Inc. ("Discoverly," "we," "our," or "us"). These Terms of Service ("Terms") govern your use of our mobile app, website, and related services (collectively, the "Service").
          </p>
          <p>
            By accessing or using Discoverly, you agree to these Terms. If you do not agree, please do not use our Service.
          </p>

          <section>
            <h2>1. Eligibility</h2>
            <p>
              You must be at least 13 years old to use Discoverly. The Service is available worldwide, except where prohibited by law. By using Discoverly, you confirm that you can legally enter into this agreement.
            </p>
          </section>

          <section>
            <h2>2. Your Account</h2>
            <p>
              To use certain features, you may need to create an account with a valid email address.
            </p>
            <p>You are responsible for:</p>
            <ul>
              <li>Keeping your login credentials secure;</li>
              <li>Any activity under your account; and</li>
              <li>Notifying us immediately if you suspect unauthorized access.</li>
            </ul>
            <p>
              We may suspend or terminate accounts that violate these Terms.
            </p>
          </section>

          <section>
            <h2>3. User Content</h2>
            <p>
              You may post photos, text, polls, and other materials ("User Content") on Discoverly.
            </p>
            <p>
              By posting, you grant Discoverly a worldwide, non-exclusive, royalty-free, transferable license to use, host, store, display, reproduce, modify, and distribute your content as needed to operate and improve the Service.
            </p>
            <p>You retain ownership of your content. However, you are responsible for ensuring it:</p>
            <ul>
              <li>Does not infringe on others' rights or intellectual property;</li>
              <li>Does not contain unlawful, offensive, or misleading material;</li>
              <li>Complies with these Terms and our Community Guidelines (if applicable).</li>
            </ul>
            <p>
              We may remove or restrict content that violates these rules.
            </p>
          </section>

          <section>
            <h2>4. Intellectual Property</h2>
            <p>
              All Discoverly trademarks, logos, and proprietary materials are owned by Flux Software, Inc.
            </p>
            <p>
              You may not copy, modify, distribute, or use our branding or code without written permission.
            </p>
          </section>

          <section>
            <h2>5. Affiliate Links and Third-Party Sites</h2>
            <p>
              Discoverly includes links to third-party products and merchant websites.
            </p>
            <p>
              When you click on a product, you are leaving our platform.
            </p>
            <p>
              We may earn a commission through affiliate links, but we do not sell or fulfill products ourselves.
            </p>
            <p>
              We are not responsible for the content, accuracy, or practices of third-party sites.
            </p>
          </section>

          <section>
            <h2>6. Privacy</h2>
            <p>
              Your privacy matters to us. Our <Link to="/privacy">Privacy Policy</Link> explains how we collect and use your information (including email, photos, and activity data).
            </p>
            <p>
              By using Discoverly, you agree to our collection and use of information as described there.
            </p>
          </section>

          <section>
            <h2>7. Prohibited Conduct</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Use Discoverly for unlawful purposes;</li>
              <li>Post spam, misleading, or harmful content;</li>
              <li>Attempt to access others' accounts or interfere with the Service;</li>
              <li>Use automated scripts or scraping tools; or</li>
              <li>Reverse-engineer or attempt to copy our software.</li>
            </ul>
            <p>
              We reserve the right to take appropriate action, including suspension or termination of accounts, for violations.
            </p>
          </section>

          <section>
            <h2>8. Termination</h2>
            <p>
              We may suspend or terminate your account at any time if you violate these Terms or misuse the Service.
            </p>
            <p>
              You may stop using Discoverly at any time.
            </p>
            <p>
              Upon termination, your license to use Discoverly ends, but sections 3, 4, 5, 8, 9, and 10 remain in effect.
            </p>
          </section>

          <section>
            <h2>9. Disclaimers</h2>
            <p>
              Discoverly is provided "as is" and "as available," without warranties of any kind.
            </p>
            <p>
              We do not guarantee uninterrupted service, accuracy of content, or that the Service will meet your expectations.
            </p>
          </section>

          <section>
            <h2>10. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, Flux Software, Inc. and its affiliates are not liable for any indirect, incidental, special, or consequential damages arising from your use of Discoverly.
            </p>
            <p>
              Our total liability shall not exceed $100 USD or the amount you paid us (if any) in the past 12 months.
            </p>
          </section>

          <section>
            <h2>11. Governing Law and Disputes</h2>
            <p>
              These Terms are governed by the laws of the State of Delaware, USA, excluding conflict of law principles.
            </p>
            <p>
              Any dispute will be resolved exclusively in the state or federal courts located in Delaware.
            </p>
          </section>

          <section>
            <h2>12. Changes to These Terms</h2>
            <p>
              We may update these Terms from time to time. If we make material changes, we'll notify you by email or in-app notice.
            </p>
            <p>
              By continuing to use Discoverly after updates, you agree to the revised Terms.
            </p>
          </section>

          <section>
            <h2>13. Contact Us</h2>
            <p>
              Flux Software, Inc.<br/>
              Email: <a href="mailto:gevorg@joindiscoverly.com">gevorg@joindiscoverly.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;

